import { Sparkles } from "lucide-react";

/**
 * BrandMark — unique source of truth for the app brand display.
 *
 * Variants:
 *  - "compact" (default): icon + "Nexaforge." with trailing primary dot. Use in sidebar / auth headers.
 *  - "full": icon + "Nexaforge Prospect Solutions" on one line (no truncation expected).
 *  - "stacked": "Nexaforge." big + "Prospect Solutions" muted underneath. Use for landing hero.
 */
export default function BrandMark({ variant = "compact", className = "", iconSize = 16 }) {
  if (variant === "stacked") {
    return (
      <div className={`flex items-center gap-3 ${className}`}>
        <div className="h-10 w-10 rounded-lg bg-primary/12 flex items-center justify-center shrink-0">
          <Sparkles style={{ width: iconSize, height: iconSize }} className="text-primary" />
        </div>
        <div className="leading-tight">
          <div className="font-semibold tracking-tight text-base">
            Nexaforge<span className="text-primary">.</span>
          </div>
          <div className="text-[10px] uppercase tracking-[0.18em] text-muted-foreground font-medium">
            Prospect Solutions
          </div>
        </div>
      </div>
    );
  }
  if (variant === "full") {
    return (
      <div className={`flex items-center gap-2 ${className}`}>
        <div className="h-8 w-8 rounded-lg bg-primary/12 flex items-center justify-center shrink-0">
          <Sparkles style={{ width: iconSize, height: iconSize }} className="text-primary" />
        </div>
        <div className="font-semibold tracking-tight text-[14px] whitespace-nowrap">
          Nexaforge<span className="text-primary"> </span>Prospect Solutions
        </div>
      </div>
    );
  }
  // compact (default)
  return (
    <div className={`flex items-center gap-2.5 ${className}`}>
      <div className="h-8 w-8 rounded-lg bg-primary/12 flex items-center justify-center shrink-0">
        <Sparkles style={{ width: iconSize, height: iconSize }} className="text-primary" />
      </div>
      <div className="font-semibold tracking-tight text-[15px]">
        Nexaforge<span className="text-primary">.</span>
      </div>
    </div>
  );
}

export const BRAND_NAME = "Nexaforge Prospect Solutions";
export const BRAND_SHORT = "Nexaforge";
